import { genericFormatter, getFileDetails } from '@askporter/utils';

/**
 * Builds the display name shown in the preview header from a file path. Signed URLs carry a query string, so
 * the name and extension are read with `getFileDetails` rather than by slicing the path.
 *
 * @param filePath - the file path or signed URL, for example /files/ap/quote.pdf?X-Amz-Signature=abc
 * @returns the file name with its extension, for example quote.pdf
 */
export const getPreviewFileName = (filePath: string | undefined): string => {
  const { name, type } = getFileDetails(filePath);

  return genericFormatter([name, type ?? ''], '.');
};
